// extracted by mini-css-extract-plugin
export default {"Conflict":"Conflict_Conflict__udlEv","Conflict__message_container":"Conflict_Conflict__message_container__wBsQK","Conflict__button":"Conflict_Conflict__button__0yN1K"};